<template>
  <error-message
    v-model="isShown"
    :title="errorMessageConfig?.title || 'Критическая ошибка'"
    :is-error="isError"
    @close="close"
  >
    <template #subtitle>
      <span v-if="errorMessageConfig?.message" v-html="errorMessageConfig.message" />
      <template v-else>Попробуйте ещё раз, или обратитесь в техническую Поддержку</template>
    </template>

    <e-textarea
      v-if="errorMessageConfig && isError"
      :model-value="errorMessageConfig.textareaMessage"
      readonly
      class="mt-3"
      rows="8"
    >
      <template v-if="errorMessageConfig.textareaMessage" #append-inner>
        <copy-to-clipboard :text="errorMessageConfig.textareaMessage" />
      </template>
    </e-textarea>

    <div v-if="isError" class="d-flex justify-space-between flex-wrap mt-4">
      <e-btn variant="ghost" @click="close">Закрыть</e-btn>
      <e-btn variant="primary" @click="openSupportDialog">Обратиться в Техподдержку</e-btn>
    </div>
  </error-message>

  <contacting-support-dialog
    v-if="isError && errorMessageConfig?.textareaMessage"
    v-model="isSupportDialogOpened"
    :message="errorMessageConfig.textareaMessage"
  />
</template>

<script setup lang="ts">
import { ref, toRef } from 'vue';
import CopyToClipboard from '@/core/components/buttons/CopyToClipboard.vue';
import { EBtn, ETextarea } from '@/core/components/ui';
import { ErrorMessageType, useErrorMessage } from '@/core/composables/useErrorMessage';
import ErrorMessage from '@/parts/errors/components/ErrorMessage.vue';
import ContactingSupportDialog from '@/parts/support/components/ContactingSupportDialog.vue';

const { errorMessageConfig, isShown, close } = useErrorMessage();

const isError = toRef(() => errorMessageConfig.value?.type === ErrorMessageType.Error);

const isSupportDialogOpened = ref(false);

const openSupportDialog = () => {
  isSupportDialogOpened.value = true;
};
</script>

<style scoped lang="scss"></style>
